import { RefreshCw, WifiOff, AlertCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { DrfApiError } from '@/services/drfRequest'

function isOffline(error: unknown): boolean {
  return (error instanceof DrfApiError && error.status === 0) || navigator.onLine === false
}

/**
 * «No se ha podido cargar», diciendo si es la conexión o el servidor y con el
 * botón para volver a intentarlo ahí mismo. Es el mismo aviso en todas las
 * pantallas de campañas, porque un fallo es lo último que debe parecer distinto.
 */
export function LoadError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  const { t } = useTranslation()
  const offline = isOffline(error)
  const Icon = offline ? WifiOff : AlertCircle

  return (
    <Alert variant="destructive">
      <Icon className="h-4 w-4" />
      <AlertTitle>{offline ? t('campaigns.common.offline_title') : t('campaigns.common.load_error_title')}</AlertTitle>
      <AlertDescription className="space-y-2">
        <p>
          {offline
            ? t('campaigns.common.offline_description')
            : error instanceof Error
              ? error.message
              : t('campaigns.common.load_error_description')}
        </p>
        <Button variant="outline" size="xs" onClick={onRetry}>
          <RefreshCw className="mr-2 h-4 w-4" />
          {t('campaigns.common.retry')}
        </Button>
      </AlertDescription>
    </Alert>
  )
}
